import { render, staticRenderFns } from "./close-x.vue?vue&type=template&id=366ced3d&scoped=true"
import script from "./close-x.vue?vue&type=script&lang=js"
export * from "./close-x.vue?vue&type=script&lang=js"
import style0 from "./close-x.vue?vue&type=style&index=0&id=366ced3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ced3d",
  null
  
)

export default component.exports